module.exports = __webpack_public_path__ + "img/freespin_feature.c893e072.png";